module.exports = __webpack_public_path__ + "static/media/esl.29854541.svg";